/**
 * Buy Now Button Handler (product cards)
 * Adds the product to the cart and opens the cart drawer.
 * Falls back to the cart page when the drawer is not available.
 */

document.addEventListener('DOMContentLoaded', function () {
    const fallbackMessage = 'Não foi possível adicionar o produto ao carrinho. Por favor, tente novamente.';

    function resetButton(button) {
        button.classList.remove('btn--loading');
        button.removeAttribute('aria-disabled');
    }

    document.addEventListener('click', async function (e) {
        const buyNowButton = e.target.closest('.product-card__buy-now');
        if (!buyNowButton) return;

        e.preventDefault();

        // Prevent multiple clicks
        if (buyNowButton.disabled || buyNowButton.getAttribute('aria-disabled') === 'true') {
            return;
        }

        const variantId = buyNowButton.dataset.variantId;
        if (!variantId) {
            console.error('No variant ID found');
            return;
        }

        const theme = window.FoxTheme || {};
        const cartDrawer = document.querySelector('cart-drawer');
        const useDrawer = cartDrawer && theme.settings && theme.settings.cartType !== 'page' && theme.pubsub;
        const cartAddUrl = (theme.routes && theme.routes.cart_add_url) || '/cart/add';
        const cartUrl = (theme.routes && theme.routes.cart_url) || '/cart';

        buyNowButton.classList.add('btn--loading');
        buyNowButton.setAttribute('aria-disabled', 'true');

        // Ask the theme which sections must be re-rendered (cart drawer, cart count, etc.)
        const sectionsToBundle = [];
        if (useDrawer) {
            document.documentElement.dispatchEvent(
                new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
            );
        }

        const body = { items: [{ id: variantId, quantity: 1 }] };
        if (sectionsToBundle.length) {
            body.sections = sectionsToBundle.join(',');
            body.sections_url = window.location.pathname;
        }

        try {
            const response = await fetch(`${cartAddUrl}.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(body)
            });
            const parsedState = await response.json().catch(() => ({}));

            if (!response.ok || parsedState.status) {
                resetButton(buyNowButton);
                alert(parsedState.description || parsedState.message || fallbackMessage);
                return;
            }

            if (!useDrawer) {
                window.location.href = cartUrl;
                return;
            }

            const cartJson = await (await fetch(`${cartUrl}.js`, { headers: { 'Accept': 'application/json' } })).json();
            cartJson.sections = parsedState.sections;

            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
            document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsedState } }));

            resetButton(buyNowButton);
            cartDrawer.show(buyNowButton);
        } catch (error) {
            console.error('Error adding to cart:', error);
            resetButton(buyNowButton);
            alert(fallbackMessage);
        }
    });
});
